import {
  Box,
  FormControlLabel,
  Stack,
  Switch,
  Typography,
} from "@mui/material";
import CircularProgress from "@mui/material/CircularProgress";
import { useEffect, useState } from "react";
import { getJoosepProject } from "../../Controllers/projectController";

const setProjects = async (
  oldCode,
  newCode,
  setAlert,
  setJoosepProjects,
  setSyncToJoosep,
  setLoading,
) => {
  setLoading(true);
  const projects = await getJoosepProject(oldCode, newCode, setAlert);
  if (projects === false) {
    setSyncToJoosep(false);
  } else {
    setSyncToJoosep(true);
  }
  setJoosepProjects(projects);
  setLoading(false);
};

const JoosepCompare = ({
  newCode,
  project,
  syncToJoosep,
  setSyncToJoosep,
  setAlert,
}) => {
  const [joosepProjects, setJoosepProjects] = useState([]);
  const [loading, setLoading] = useState(false);
  useEffect(() => {
    setProjects(
      project.code,
      newCode,
      setAlert,
      setJoosepProjects,
      setSyncToJoosep,
      setLoading,
    );
  }, []);

  if (loading)
    return (
      <Box sx={{ display: "flex", justifyContent: "center", p: 2 }}>
        <CircularProgress />
      </Box>
    );

  return (
    <Stack direction="column">
      {joosepProjects === false && (
        <Typography color="red" fontWeight="bold">
          An unexpected error occured while trying to get project from Joosep.
        </Typography>
      )}
      {joosepProjects !== false &&
        joosepProjects.length !== 0 &&
        joosepProjects.map((p) => {
          const start = project.start_date.split("-").reverse().join(".");
          const end = project.end_date.split("-").reverse().join(".");
          const isOld = p.projkood === project.code && project.code !== newCode;
          const matchingName =
            p.projnimi ===
            `${project.acronym ? `${project.acronym}: ` : ""}${project.name}, ${start}-${end} (${project.project_manager_name})`;
          const matchingCode = p.projkood === newCode;
          return (
            <Stack direction="column" paddingBottom={1} key={p.projkood}>
              {isOld ? (
                <Typography fontSize={20}>
                  Currently matching project in Joosep
                </Typography>
              ) : matchingName && matchingCode ? (
                <Typography fontSize={20}>
                  There are no changes to Joosep
                </Typography>
              ) : (
                <Typography fontSize={20}>Changes to Joosep</Typography>
              )}

              <Stack direction="row" alignItems={"center"} spacing={1}>
                <Typography>Name:</Typography>
                <Typography>
                  {p.projnimi}
                  {!isOld && !matchingName && (
                    <strong>
                      {" => "}
                      {`${project.acronym ? `${project.acronym}: ` : ""}${project.name}, ${start}-${end} (${project.project_manager_name})`}
                    </strong>
                  )}
                </Typography>
              </Stack>

              <Stack direction="row" alignItems={"center"} spacing={1}>
                <Typography>Code:</Typography>
                <Typography>
                  {p.projkood}
                  {!isOld && !matchingCode && (
                    <strong>
                      {" => "}
                      {newCode}
                    </strong>
                  )}
                </Typography>
              </Stack>
            </Stack>
          );
        })}

      {joosepProjects !== false &&
        (joosepProjects.length === 0 ||
          (joosepProjects.length === 1 &&
            joosepProjects[0].projkood === project.code &&
            project.code !== newCode)) && (
          <Stack direction="column">
            <Typography paddingBottom={1} fontSize={20}>
              Create new project in Joosep
            </Typography>
            <Stack direction="row" alignItems={"center"} spacing={1}>
              <Typography>Name:</Typography>
              <Typography>
                {`${project.acronym ? `${project.acronym}: ` : ""}${project.name}, ${project.start_date
                  .split("-")
                  .reverse()
                  .join(".")}-${project.end_date
                  .split("-")
                  .reverse()
                  .join(".")} (${project.project_manager_name})`}
              </Typography>
            </Stack>
            <Stack direction="row" alignItems={"center"} spacing={1}>
              <Typography>Code:</Typography>
              <Typography>{newCode}</Typography>
            </Stack>
            {/* <Stack direction="row" alignItems={"center"} spacing={1}>
            <Typography>Manager:</Typography>
            <Typography>{project.project_manager_name}</Typography>
          </Stack>
          <Stack direction="row" alignItems={"center"} spacing={1}>
            <Typography>Start:</Typography>
            <Typography>{project.start_date}</Typography>
          </Stack>
          <Stack direction="row" alignItems={"center"} spacing={1}>
            <Typography>End:</Typography>
            <Typography>{project.end_date}</Typography>
          </Stack> */}
          </Stack>
        )}
      <Typography paddingTop={2} fontWeight={"bold"}>
        NB! This sync can only change the name(projnimi) of a project in Joosep
        or create a new one! Changes to code must be made manually!
      </Typography>
      {setSyncToJoosep && (
        <Box
          sx={{
            position: "relative",
            border: "1px solid rgba(0, 0, 0, 0.23)", // matches TextField default
            borderRadius: 1,
            p: 1,
            mt: 2,
          }}
        >
          <FormControlLabel
            control={
              <Switch
                checked={syncToJoosep}
                onChange={(event, checked) => {
                  setSyncToJoosep(checked);
                }}
              />
            }
            label="Sync to Joosep"
            labelPlacement="start"
            sx={{
              // make the label span only hug its text
              "& .MuiFormControlLabel-label": {
                cursor: "pointer",
                width: "auto",
                fontWeight: "bold",
              },
              width: "fit-content", // collapse whole thing
            }}
          />
        </Box>
      )}
    </Stack>
  );
};

export default JoosepCompare;
